export const VIEW_AS_HEADER = "VIEW-AS";

const VIEW_AS_QUERY_PARAM = "view-as";

/**
 * Reads the 'view as' impersonation context the host app forwards via the iframe URL.
 * Returns the raw serialized value (a JSON string) to be sent back as the VIEW-AS header,
 * or null when not impersonating.
 */
export function getViewAsParam(): string | null {
  return new URLSearchParams(window.location.search).get(VIEW_AS_QUERY_PARAM);
}
